<template>
  <BlockTextImage :title="schema.title" :color="pbblocktextimagecolor" :background="generateLink(schema.image.formats.medium.url)">
    <div v-html="generateText()"></div>
  </BlockTextImage>
</template>

<script>
import BlockTextImage from "@/components/blocks/BlockTextImage.vue";

import { marked } from "marked";

export default {
  name: "pb-blocktextimage",
  components: {
    BlockTextImage,
  },
  props: {
    schema: {
      type: Object,
    },
  },
  data() {
    return {
      pbblocktextimagecolor: "red",
    };
  },
  mounted() {
    this.generateColor();
  },
  updated() {
    this.generateColor();
    this.generateText();
  },
  methods: {
    generateLink(link) {
      console.log("generate link");
      if (link.startsWith("/")) {
        return process.env.VUE_APP_MERITECMS_URL.slice(0, -1) + link;
      } else {
        return link;
      }
    },
    generateText() {
      return marked(this.schema.text);
    },
    generateColor() {
      if (this.schema.color == "benevolat") {
        this.pbblocktextimagecolor = "var(--charte-color-benevolat)";
      } else if (this.schema.color == "talent") {
        this.pbblocktextimagecolor = "var(--charte-color-talent)";
      } else if (this.schema.color == "sport") {
        this.pbblocktextimagecolor = "var(--charte-color-sport)";
      } else if (this.schema.color == "residentiel") {
        this.pbblocktextimagecolor = "var(--charte-color-residentiel)";
      } else if (this.schema.color == "expedition") {
        this.pbblocktextimagecolor = "var(--charte-color-expedition)";
      } else {
        this.pbblocktextimagecolor = "var(--charte-color-talent)";
      }
    },
  },
};
</script>

<style></style>
